import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseMultipleSessions: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'multiple-sessions') && isFeatureEnabled(rootGetters, 'release-data-mart-individual-report-v2')
  },
  canUseShareDocs: (_, getters, ___, rootGetters) => {
    return getters.canUseMultipleSessions && isFeatureEnabled(rootGetters, 'share-docs-with-multi-sessions')
  },
  selectedSession: (state) => {
    return state.selectedSession
  },
  isRenderedReport: (state) => {
    return state.isRenderedReport
  },
  isCreatingNewSession: (state) => {
    return state.isCreatingNewSession
  },
}

export default _getters
